module.exports = __webpack_public_path__ + "static/media/Floating Point.3853d2d6.jpg";